import { UpgradeAccountPage } from './UpgradeAccountPage';
export default UpgradeAccountPage;
